import React from 'react';

import visa from '@commonTuna/react/images/cardBrands/visa.svg';
import masterCard from '@commonTuna/react/images/cardBrands/mastercard.svg';
import amex from '@commonTuna/react/images/cardBrands/amex.svg';
import discover from '@commonTuna/react/images/cardBrands/discover.svg';
import googlePay from '@commonTuna/react/images/cardBrands/googlePayMark.png';
import applePay from '@commonTuna/react/images/cardBrands/applePayMark.svg';

import cards from '@images/PaymentProcessing/cards.png';
import terminal from '@images/PaymentProcessing/pos.png';

const PaymentsInfo: React.FC = () => {
	const cardBrands = [visa, masterCard, amex, discover, googlePay, applePay];
	const cardBrandNames = ['visa', 'masterCard', 'amex', 'discover', 'googlePay', 'applePay'];

	const cardBrandLogo = cardBrands.map((logo, index) => {
		const name = cardBrandNames[index];
		return (
			<div className={`card-brands__item ${name}`} key={name}>
				<img src={logo} alt={name} />
			</div>
		);
	});

	return <section className="payments-info payments-processing__item">
		<div className="payments-info__container payments-processing__container">
			<div className="payments-info__top">
				<div className="payments-info__text-block text-block">
					<h1 className="text-block__title">Payment Processing</h1>
					<div className="text-block__text">
						<p>
							Northern Tuna provides an integrated digital platform that enables clinics and healthcare centers to accept and process
							payments from customers in an efficient and secure manner. Customers' sensitive payment data are securely protected and
							not transferred to third parties.
						</p>
						<p>
							The platform includes a variety of features such as the ability to accept a wide range of payment methods, including
							credit and debit cards, e-checks, and digital wallets. Additionally, the platform offers fraud detection and prevention
							tools, as well as detailed reporting and analytics to help businesses track and understand their transactions.
						</p>
					</div>
					<div className="text-block__buttons">
						<a href="/payments-processing#request-demo" className="text-block__button">
							request a demo
						</a>
						<a href="/payments-processing#terminals" className="text-block__link black-link">learn more</a>
					</div>
				</div>
				<div className="payments-info__image image-block">
					<div className="image-block__img terminal-img">
						<img src={terminal} alt="Terminal" />
					</div>
					<div className="image-block__img cards-img">
						<img src={cards} alt="Cards" />
					</div>
				</div>
			</div>
			<div className="payments-info__card-brands">
				{cardBrandLogo}
			</div>
		</div>
	</section>;
};

export default PaymentsInfo;
